//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { withReferral } from '@helpers/referrals';
import { StoreConfigContext } from '@helpers/storeConfigContext';
import Product from '../product';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class List extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { products, t, i18n, listId, listName, reviews = {} } = this.props;
    if (!products?.length)
      return (
        <p className={styles.NoResultsText}>{t('dashboard_NoResultsFound')}</p>
      );
    const componentClasses = classNames(styles.List);

    return (
      <ul className={componentClasses}>
        {products.map((item, index) => {
          const review = reviews[item.id];

          return (
            <Product
              key={item.id}
              metadata={{ index, listName, listId }}
              item={item}
              t={this.t}
              i18n={i18n}
              review={review}
            />
          );
        })}
      </ul>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withReferral(withTranslation()(List));

List.contextType = StoreConfigContext;
